<template>
    <CSidebar
        :minimize="minimize"
        unfoldable
        :show="show"
        @update:show="value => $store.commit('set', ['sidebarShow', value])"
        colorScheme="dark"
        style="background-color: #272F51;"
    >
        <!-- <CSidebarBrand class="d-md-down-none" to="/"> </CSidebarBrand> -->
        <CRenderFunction flat :contentToRender="this.$options.admin" />
        <!-- <CSidebarMinimizer
            class="c-d-md-down-none"
            @click.native="$store.commit('toggle', 'sidebarMinimize')"
        /> -->
    </CSidebar>
</template>

<script>
import { admin } from './_nav';

export default {
    name: 'TheSidebar',
    admin,
    data() {
        return {
            count: this.$store.state.userCount
        };
    },
    computed: {
        show() {
            return this.$store.state.sidebarShow;
        },
        minimize() {
            this.$store.state.sidebarMinimize;
        },
        role() {
            return this.$store.state.role;
        }
    }
};
</script>
